import "./App.css";
import MyDocument from "./pdf_renderer";

function App() {
  return (
    <div style={{ width: "100vw", height: "100vh", padding: 0, margin:0, overflow: "hidden" }}>
        <MyDocument />
    </div>
  );
}

export default App;
